import { Stack } from '@mui/material';
import { t } from 'i18next';
import SbtLogo from '../../../assets/images/sbt-logo.svg';

export const PresetSubtitle = () => {
  return (
    <Stack component="span" direction="row" alignItems="center" gap={1} sx={{ pt: 1 }}>
      <SbtLogo title={t('a11y.organization.profiles.preset')} height="18" width="18" viewBox="0 0 52 57" fill="#E5A724" />
      {t('a11y.organization.profiles.preset')}
    </Stack>
  );
};
